import { STORE_FLAGSMITH_DATA } from '../../action-contants';

/* Defining Types */
type flagType = {
  id: number;
  enabled: boolean;
  value: any;
};

export type reducerActionType = {
  data: flagType[];
  type: string;
};

/* Initial state of Reducer */
const INITIAL_STATE = {
  flags: null
};

export default function flagsmithReducer(state = INITIAL_STATE, action: reducerActionType) {
  switch (action.type) {
    case STORE_FLAGSMITH_DATA: {
      return {
        ...state,
        flags: action.data
      };
    }
    default:
      return state;
  }
}
